import TestimonialDoubleMarks from '@rsa-digital/evo-shared-components/components/Testimonial/TestimonialDoubleMarks';
import { graphql } from 'gatsby';
import React from 'react';

export type TestimonialProps = {
  header_text: string | null;
  testimonials: {
    quote: string;
    screen_reader_text: string;
    author?: {
      author_name: string | null;
      author_job_title: string | null;
    };
  }[];
};

type TestimonialBlockProps = {
  testimonial: TestimonialProps;
};

export const query = graphql`
  fragment TestimonialBlock on cs__testimonial {
    header_text
    testimonials {
      quote
      screen_reader_text
      author {
        author_job_title
        author_name
      }
    }
  }
`;

const TestimonialBlock: React.FC<TestimonialBlockProps> = ({ testimonial }) => (
  <TestimonialDoubleMarks
    data-cy="Testimonial"
    headerText={testimonial.header_text ?? undefined}
    testimonials={testimonial.testimonials.map((aTestimonial) => ({
      quote: aTestimonial.quote,
      screenReaderText: aTestimonial.screen_reader_text,
      author: {
        authorName: aTestimonial.author?.author_name ?? undefined,
        authorJobTitle: aTestimonial.author?.author_job_title ?? undefined,
      },
    }))}
    showAuthor
  />
);

export default React.memo(TestimonialBlock);
